'use client'

import { AppSidebar } from './AppSidebar'
import { ImpersonationBanner } from './ImpersonationBanner'
import { EmailConfirmationBanner } from './EmailConfirmationBanner'

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex h-screen overflow-hidden bg-background relative">
      {/* Animated background gradient overlays with warm colors */}
      <div className="fixed inset-0 bg-gradient-to-br from-orange-50/40 via-transparent to-amber-50/30 dark:from-orange-950/10 dark:via-transparent dark:to-amber-950/10 pointer-events-none animate-[gradient-shift_15s_ease_infinite]" />
      <div className="fixed inset-0 bg-gradient-to-tl from-rose-50/30 via-transparent to-orange-50/40 dark:from-rose-950/8 dark:via-transparent dark:to-orange-950/10 pointer-events-none animate-[gradient-shift_20s_ease_infinite]" />
      <div className="fixed inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 pointer-events-none" />
      <div className="fixed inset-0 bg-gradient-to-tl from-accent/3 via-transparent to-primary/3 pointer-events-none" />
      {/* Subtle dot pattern */}
      <div className="fixed inset-0 bg-pattern opacity-30 pointer-events-none" />
      <AppSidebar />
      <main className="flex-1 overflow-y-auto overflow-x-hidden relative z-10">
        <ImpersonationBanner />
        <EmailConfirmationBanner />
        <div className="w-full h-full md:pt-0 pt-12 pb-6 md:pb-8">
          {children}
        </div>
      </main>
    </div>
  )
}

